import { KeycloakConfig } from 'keycloak-js';

export const keycloakConfigDevelopment: KeycloakConfig = {
  realm: 'luftborn-dss-dev',
  url: 'https://luftborn-dss-develop-keycloak.azurewebsites.net',
  clientId: 'frontend',
};
